if (!Element.prototype.matches)
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this
    if (!document.documentElement.contains(el)) return null
    do {
      if (el.matches(s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

document.addEventListener('DOMContentLoaded', function() {
  var controllers = document.getElementsByClassName('js-accordion-controller')

  for (var i = 0; i < controllers.length; i++) {
    // Adds is-collapsed class if JS is enabled (otherwise leave everything open and visible)
    controllers[i]
      .closest('.js-accordion-container')
      .classList.toggle('is-collapsed')

    // Binding event listeners, to toggle collapsed state on click
    controllers[i].addEventListener('click', function() {
      var container = this.closest('.js-accordion-container')
      container.classList.toggle('is-collapsed')
    })
  }
})
